/** @jsx isolateComponent */
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { css } from '@emotion/react';
import { ReactNode, Children } from 'react';

export type Props = {
  children: ReactNode;
  /**
   * Set a max number of columns for rendered on a row
   */
  maxColumns?: number;
  /**
   * max-width in pixels applied to the content area of container.
   */
  maxWidth?: number;
};

const breakpoints = {
  tablet: 768,
  desktop: 1230,
};

const Styles = labelStyles('BlockGrid', {
  root: ({
    childrenLength,
    maxColumns,
    maxWidth,
  }: {
    childrenLength: number;
    maxColumns: number;
    maxWidth: number;
  }) =>
    css`
      display: grid;
      align-items: flex-start;
      gap: 50px 30px;
      max-width: ${maxWidth}px;
      margin: auto;
      grid-template-columns: repeat(${childrenLength}, 1fr);

      // Two columns if tablet and two children, otherwise one column.
      @media screen and (max-width: ${breakpoints.desktop}px) {
        grid-template-columns: repeat(
          ${childrenLength === 2 || maxColumns === 2 ? 2 : 1},
          1fr
        );
      }

      // One column if mobile
      @media screen and (max-width: ${breakpoints.tablet}px) {
        grid-template-columns: repeat(1, 1fr);
      }
    `,
});

export const BlockGrid = ({ children, maxColumns, maxWidth = 1170 }: Props) => {
  const childrenLength = maxColumns || Children.toArray(children).length;

  return (
    <div css={Styles.root({ childrenLength, maxColumns, maxWidth })}>
      {children}
    </div>
  );
};
